import React from 'react';
import { TutorialsPageData as pageData } from '../../utils/pageContent';

const TextareaWithLabel = ({
  id,
  label,
  containerClassName,
  labelClassName,
  labelMargin,
  errorMargin,
  errorSize,
  className,
  disabled,
  isRequired,
  value,
  error,
  limit,
  isLengthValidate,
  ...props
}) => {
  const sectionData = pageData.editTutorialPageData.tutorialInfoSection.faqFormSection;
  return (
    <div className={containerClassName}>
      {label && (
        <div className="flex items-center justify-between">
          <label
            htmlFor={id}
            className={`font-medium text-shoorah-lightBlack dark:text-white ${
              labelMargin ? labelMargin : 'mb-2'
            } block ${labelClassName ? labelClassName : ''}`}
          >
            {label}
            {isRequired && !disabled && <span className="text-red-500"> &#42;</span>}
          </label>
          {isLengthValidate && !disabled && (
            <span className="mt-1 float-right text-red-500 text-[12px]">
              {value?.length <= limit
                ? limit - value?.length + sectionData.characterLeftText
                : sectionData.outOf100Text}
            </span>
          )}
        </div>
      )}
      <textarea
        autoComplete="off"
        id={id}
        value={value}
        disabled={disabled}
        className="flex justify-center items-center overflow-hidden p-4 rounded-[9px] border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder w-full h-[240px] bg-shoorah-normanGray dark:bg-shoorah-darkBgColor relative"
        {...props}
      ></textarea>
      {error && (
        <p
          className={`text-red-500 ${errorSize ? errorSize : 'text-sm'} ${
            errorMargin ? errorMargin : 'mt-2'
          }`}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default TextareaWithLabel;
